import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/StatusPage.css';

function TechnicianPending() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const handleSignOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <div className="sp-page">
      <div className="sp-card">

        <div className="sp-icon sp-icon--pending">
          <svg viewBox="0 0 24 24" width="40" height="40" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.6" />
            <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 className="sp-title">Application Under Review</h1>
        <p className="sp-greeting">Hi {user.full_name || 'there'},</p>
        <p className="sp-body">
          Thank you for registering with SkillArea. Your account is currently under review by our
          admin team. We verify all technician credentials before granting access to ensure quality
          and trust for hirers on our platform.
        </p>

        <div className="sp-timeline">
          <div className="sp-step sp-step--done">
            <span className="sp-dot" />
            <span>Application submitted</span>
          </div>
          <div className="sp-step sp-step--active">
            <span className="sp-dot" />
            <span>Admin review in progress</span>
          </div>
          <div className="sp-step">
            <span className="sp-dot" />
            <span>Access granted</span>
          </div>
        </div>

        <p className="sp-hint">
          You will receive an email once your account has been reviewed. This typically takes
          1–2 business days. If you have questions, please contact our support team.
        </p>

        <div className="sp-actions">
          <button className="sp-btn sp-btn--ghost" onClick={() => navigate('/contact')}>
            Contact Support
          </button>
          <button className="sp-btn" onClick={handleSignOut}>
            Sign Out
          </button>
        </div>

      </div>
    </div>
  );
}

export default TechnicianPending;
